import type { Socket } from "socket.io-client";

export const useGlobalSockets = () => {
  // ВАЖНО: НЕ вызываем useNuxtApp() и useRuntimeConfig() на верхнем уровне
  // Это вызовет ошибку на SSR если composable вызывается из app.vue
  const socket = ref<Socket | null>(null);
  const isJoined = ref<boolean>(false);

  const connect = (token: string) => {
    const { $io } = useNuxtApp() as any;
    if (!$io) return;
    const config = useRuntimeConfig();
    const socketConfig = {
      auth: { token },
      extraHeaders: { Authorization: `Bearer ${token}` },
    };
    socket.value = $io(`${config.public.SOCKET_API_URL}/event`, socketConfig);
  };

  const disconnect = () => {
    socket.value?.disconnect();
    socket.value = null;
  };

  const joinGlobal = () => {
    if (!socket.value) return;
    socket.value.emit("joinGlobal");
  };

  // Обработчик, зарегистрированный этим экземпляром composable.
  // socket.io отдаёт один и тот же Socket на namespace, поэтому подписчиков может
  // быть несколько (app.vue + страница). Раньше здесь вызывался socket.off("event"),
  // который снимал ВСЕ обработчики: последний вызвавший «забирал» событие себе,
  // а остальные переставали его получать.
  let ownEventHandler: ((data: any) => void) | null = null;

  const offGlobalEvent = () => {
    if (socket.value && ownEventHandler) {
      socket.value.off("event", ownEventHandler);
    }
    ownEventHandler = null;
    isJoined.value = false;
  };

  const handleGlobalEvent = (callback: (data: any) => void) => {
    if (!socket.value) return;
    // Снимаем только свой предыдущий обработчик — чужие не трогаем.
    if (ownEventHandler) socket.value.off("event", ownEventHandler);
    ownEventHandler = (data: any) => callback(data);
    socket.value.on("event", ownEventHandler);
    isJoined.value = true;
  };

  // Компонент размонтировался — снимаем его обработчик, чтобы он не висел
  // на общем сокете и не дёргал состояние уничтоженного компонента.
  if (getCurrentInstance()) {
    onUnmounted(offGlobalEvent);
  }

  const moderateAction = (data: any) => {
    if (!socket.value) return;
    socket.value.emit('event', {
      eventType: 'ModerateChannel',
      eventInfo: data,
    })
  }

  const orderAction = (data: any) => {
    if (!socket.value) return;
    socket.value.emit('event', {
      eventType: 'ModerateOrders',
      eventInfo: data,
    })
  }

  const channelAction = (data: any) => {
    if (!socket.value) return;
    socket.value.emit('event', {
      eventType: 'NewModerateChannel',
      eventInfo: data,
    })
  }

  const publisherAction = (data: any) => {
    if (!socket.value) return;
    console.log("publisherAction", data);
    socket.value.emit('event', {
      eventType: 'NewPublisherAction',
      eventInfo: data,
    })
  }


  return {
    socket,
    connect,
    disconnect,
    joinGlobal,
    handleGlobalEvent,
    offGlobalEvent,
    moderateAction,
    orderAction,
    isJoined,
    channelAction,
    publisherAction
  };
}
